import React, { useState } from "react";
import Plot from "react-plotly.js";
import { useMediaQuery } from "react-responsive";

const FavoritePlot = ({ graph}) => {
  const [GraphData, setGraphData] = useState(graph);
  const isTab = useMediaQuery({ query: "(max-width: 768px)" });

  if (Object.keys(GraphData).length === 0) {
    return <div style={{ display: "none" }}></div>;
  }

  const graphData = JSON.parse(GraphData);

  let layoutData = {};
  if (isTab) {
    layoutData = {
      ...graphData.layout,
      legend: {
        orientation: "h",
        xanchor: "center",
      },
    };
  } else {
    layoutData = {
      ...graphData.layout,
      plot_bgcolor: "transparent",   // chart area
      paper_bgcolor: "transparent",  // outer background
      autosize: true,
      hovermode: false,
      // margin: { t: 100, l: 100, r: 0, b: 0 },
      legend: {
        x: 1.2,
      },
    };
  }

  return (
    <div className="relative rounded-lg p-8 border border-gray-300 bg-gray-100">
      <Plot data={graphData.data} layout={layoutData}  useResizeHandler={true}
          style={{ width: "100%", minHeight: "400px" }}
          config={{
            displaylogo: false,
            responsive: true,
            displayModeBar: false,
            modeBarButtonsToRemove: [
              "hoverCompareCartesian",
              "hoverClosestCartesian",
            ],
          }}/>
      
    </div>
  );
};

export default FavoritePlot;
